/* eslint-disable react/jsx-indent */
/* eslint-disable indent */
import Layout from 'layout';
import { ProposalViewList } from 'features/Proposal/pages';
import { LayoutProvider } from '../layout/context/layoutcontext';

function ProjectProposalListPage() {
    return (
        <LayoutProvider>
            <Layout>
                <ProposalViewList />
            </Layout>
        </LayoutProvider>
    );
}

export default ProjectProposalListPage;
